// Whether the active customer's balance is in Chargebee, where it is used automatically before their payment method.
export default () => {
  const authStore = useAuthStore();
  const paymentStore = usePaymentStore();

  watch(
    () => [authStore.user?.id, authStore.activeRegion],
    paymentStore.fetchBalanceMigrated,
  );
  onMounted(paymentStore.fetchBalanceMigrated);

  return { balanceMigrated: computed(() => paymentStore.isBalanceMigrated) };
};
